import { ThemeEvents, VariantUpdateEvent } from '@theme/events';

if (!customElements.get('bb-product-detail-list')) {
  customElements.define('bb-product-detail-list', class extends HTMLElement {
    constructor() {
      super();
    }
    
    connectedCallback() {
      const closestSection = this.closest('.shopify-section, dialog');
      if (!closestSection) return;
      closestSection.addEventListener(ThemeEvents.variantUpdate, this.UpdateProductDetailInfo.bind(this));
    }

    async UpdateProductDetailInfo(e) {
      // console.log(e, e.detail.resource);
      let variant = e.detail.resource;
      // console.log(variant);
      let url = `${this.dataset.product_url}?section_id=${this.dataset.section_id}&variant=${variant.id}`;
      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error('Network response was not ok');
        const res_text = await res.text();
        // console.log(res_text);
        const parser = new DOMParser();
        const doc = parser.parseFromString(res_text, 'text/html');
        const new_content = doc.querySelector('bb-product-detail-list');
        // console.log(new_content);
        if (new_content) {
          this.innerHTML = new_content.innerHTML;
        }
      } 
      catch (error) {
        console.error('Error fetching product details:', error);
      }
    }
  });
}

if (!customElements.get('variant-note')) {
  class VariantNote extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      let id = this.dataset.id || '';
      this.id = id;
      let $group = this.closest('.group-block');
      this.$group = $group;

      // BB START: swap a POD print time for an estimated dispatch date (u_BB_FillPodDispatchNotes,
      // _bb-custom.js). On first page load that script isn't loaded yet and fills every note itself;
      // this call covers notes added later (e.g. a quick-add dialog).
      if (typeof u_BB_FillPodDispatchNotes === 'function') u_BB_FillPodDispatchNotes(this);
      // BB END: POD estimated dispatch

      const closestSection = this.closest('.shopify-section, dialog');
      if (!closestSection) return;
      closestSection.addEventListener(ThemeEvents.variantUpdate, this.UpdateNote.bind(this));
    }

    async UpdateNote(e) {
      // console.log(e.detail);
      const $new_variant_note = e.detail.data.html.querySelector(`variant-note[data-id="${this.id}"]`);
      // console.log(this.$group, $new_group);
      if ($new_variant_note) {
        this.innerHTML = $new_variant_note.innerHTML;
        // BB: the fresh HTML has the note's own print-time text again — re-apply the dispatch date
        if (typeof u_BB_FillPodDispatchNotes === 'function') u_BB_FillPodDispatchNotes(this);
      }
    }
  }
  customElements.define('variant-note', VariantNote);
}